import { createSlice } from "@reduxjs/toolkit";
import { fetchAgencyClients } from "./agencyConfigUtil";
import { removeAgencyClient } from "../../components/functions/utilities";

const INITIAL_STATE: IState = {
  clients: [],
  clientsLoading: true,
  currentClient: null,
  clientsObj: {},
};

interface ClientInf {
  companyType: string;
  id: number;
  name: string;
}

interface IState {
  clients: ClientInf[];
  clientsLoading: boolean;
  clientsObj: Record<string, ClientInf>;
  currentClient: ClientInf | null;
}

const agencyConfig = createSlice({
  name: "agencyConfig",
  initialState: INITIAL_STATE,
  reducers: {
    setCurrentClient: (state, action) => {
      state.currentClient = action.payload;
    },
    setClientLoading: (state, action) => {
      state.clientsLoading = action.payload;
    },
    resetAgencyConfig: (state) => {
      state.clients = [];
      state.clientsLoading = false;
      state.currentClient = null;
      state.clientsObj = {};
      removeAgencyClient();
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAgencyClients.pending, (state) => {
      state.clientsLoading = true;
    }),
      builder.addCase(fetchAgencyClients.fulfilled, (state, action) => {
        state.clients = action.payload.clients;
        state.clientsObj = action.payload.clients.reduce(
          (acc: Record<string, ClientInf>, client: ClientInf) => {
            acc[client.id] = client;
            return acc;
          },
          {}
        );
        if (!action.payload?.preSelectClientCompanyId) {
          state.currentClient = state.clients[0] || null;
        } else {
          state.currentClient =
            state.clientsObj[action.payload.preSelectClientCompanyId] || null;
        }
        state.clientsLoading = false;
      }),
      builder.addCase(fetchAgencyClients.rejected, (state, action) => {
        state.clientsLoading = false;
      });
  },
});

export const { setCurrentClient, setClientLoading, resetAgencyConfig } =
  agencyConfig.actions;

export const agencyConfigReducer = agencyConfig.reducer;
